import { stdnum } from 'stdnum';

export function formatDocValue(countryCode: string, docType: string, docValue: string): string {
  try {
    if (countryCode.toUpperCase() === 'CL' && docType.toLowerCase() === 'rut') {
      const filled = docValue.replace(/[^0-9kK]/g, '');
      const normalized = filled.length === 8 ? '0' + filled : filled;
      const formattedRUT = stdnum.CL.rut.format(normalized).replace(/^0/, '').replace(/\./g, '');
      return formattedRUT || docValue;
    }
    const formattedValue = stdnum[countryCode.toUpperCase()]?.[docType.toLowerCase()].format(docValue);
    return formattedValue || docValue;
  } catch {
    return docValue;
  }
}
